import React, { Component } from 'react';

import renderHTML from 'react-render-html';

import { DelayLink } from './';

class ListItem extends Component {

	constructor() {
        super();
	}

    componentDidMount() {
    }

    componentWillUnount() {
    }

	render() {
        return (
            <li onClick={ this.props.onClick }>
                <DelayLink to={ this.props.path } delay={1000}>{ renderHTML(this.props.text) }</DelayLink>
            </li>
    	);
	}
}

export { ListItem };